import { calculateDiffObject } from './calculateDiffObject';

export const calculateError =
	(objA, objB) =>
		Object
			.values(calculateDiffObject(objA, objB))
			.reduce((prev, current) => prev + current, 0);


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/lib/fitness/providers/NoteSizePartialFitness/calculateError.js